import PazienteAllegatiRepository from "../";

const routes = [
    { name: "PazienteAllegatiRepository", path: "/paziente/allegatirepository", component: PazienteAllegatiRepository.PazienteAllegatiRepositoryList, meta: { title: "pazienti.lblTitle" } },
];

export default routes;
